const getters = {
    loading: state => state.common.loading,
    pici_goods_num: state => state.tally.pici_goods_num,
    tallyLock: state => state.tally.lock,
    us_no: state => state.tally.us_no,
    box_no: state => state.tally.box_no,
    blp_box_no: state => state.tally.blp_box_no,
    no_data_box_no: state => state.tally.no_data_box_no,
    suit_parts_box_no: state => state.tally.suit_parts_box_no
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js